/**
 * Utilities for reinitializing third-party scripts after Turbo navigation.
 */
export default class ThirdParty {
  static #initialPageLoad = true;

  /**
   * Register a callback to run after Turbo navigation (skips initial page load).
   * @param {Function} callback - Function to call on Turbo navigation
   */
  static onTurboNavigation(callback) {
    document.addEventListener('turbo:load', () => {
      if (this.#initialPageLoad) {
        this.#initialPageLoad = false;
        return;
      }
      callback();
    });
  }

  /**
   * Reload a regular script by injecting a new script tag.
   * @param {string} url - Script URL (cache-busting timestamp added automatically)
   */
  static reloadScript(url) {
    const script = document.createElement('script');
    script.src = url + (url.includes('?') ? '&' : '?') + 't=' + Date.now();
    document.head.appendChild(script);
  }

  /**
   * Reload an ES module by dynamically importing it.
   * @param {string} url - Module URL (cache-busting timestamp added automatically)
   * @returns {Promise} - Import promise
   */
  static reloadModule(url) {
    const cleanUrl = url.split('?')[0];
    return import(cleanUrl + '?t=' + Date.now());
  }
}
